import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import useTableFilter from '../../../components/TableFilter/useTableFilter';
import { loadServiceProviderList, monitoringModule } from '../MonitoringDucks';
import StaticTablePagination from '../../../_ui/Table/StaticTablePaginated';
import React from 'react';
import { serviceProviderListColumn } from './ServiceProviderListColumn';
import ExportFile from './ExportFile';
import { Box } from '@material-ui/core';

export default function MonitoringServiceProvider() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { nextPage } = useTableFilter(
    filter => {
      dispatch(loadServiceProviderList(filter));
    },
    {
      pageNumber: 1,
      pageSize: 25
    }
  );
  const data = useSelector(state => state[monitoringModule].serviceProviderList);
  const loading = useSelector(state => state[monitoringModule].loading);

  return (
    <div>
      <Box className="mb4">
        <ExportFile />
      </Box>

      <div style={{ marginBottom: 10 }} />
      <StaticTablePagination
        loading={loading}
        sortable={false}
        columns={serviceProviderListColumn({
          t,
          lang: i18n.language
        })}
        data={data.content}
        totalElements={data.totalElements}
        onClickLoadMore={() => nextPage()}
      />
    </div>
  );
}
